import React from 'react'
import { SkeletonLoader } from '@core/Areas/FollowMe/Components/Common/SkeletonLoader'
import { SharedBetCard } from '@core/Areas/FollowMe/Components/Common/SharedBetCard'
import { PullToRefreshContainer } from '@mobi/component-library/Common/PullToRefreshContainer'
import { FeedContainerStyled } from '@core/Areas/FollowMe/Components/Common/FollowMe.styles'
import { useCopiedBetsData } from '@core/Areas/FollowMe/hooks/useCopiedBetsData'
import { EmptyTipsMessage } from '../../EmptyTipsMessage'

export const MyCopiedTips: React.FC<{ setHasCopiedBets(hasBets: boolean): void }> = ({
  setHasCopiedBets,
}) => {
  const { isLoading, data, refetch, isRefetching, LoadMoreButton } = useCopiedBetsData()

  if (data?.pages.flat().filter(Boolean).length !== 0) {
    setHasCopiedBets(true)
  }

  if (isLoading || isRefetching || !data) return <SkeletonLoader />

  if (data.pages.length === 0 || data.pages[0].length === 0) {
    return (
      <EmptyTipsMessage
        title='No Copied Tips'
        card='noContentCard2'
        description="You haven't copied any tips yet – head to the Hub to copy your first!"
      />
    )
  }

  return (
    <PullToRefreshContainer onRefresh={refetch}>
      <FeedContainerStyled>
        {data.pages.map(group =>
          group.map(sharedBet => (
            <SharedBetCard key={sharedBet.postId} sharedBet={sharedBet} isMyCopiedBet />
          ))
        )}
        <LoadMoreButton />
      </FeedContainerStyled>
    </PullToRefreshContainer>
  )
}
